import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProfileService} from "../../services/profile/profile.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-dashbaord-shell',
  templateUrl: './dashbaord-shell.component.html',
  styleUrls: ['./dashbaord-shell.component.scss']
})
export class DashbaordShellComponent implements OnInit, OnDestroy {
  bussinessName = '';
  private subscription = new Subscription();

  constructor(
    private profile: ProfileService
  ) {
  }

  ngOnInit(): void {
    this.fetchBussinessDetails({cache: true});
    this.subscription.add(this.profile.profileInfoChange.subscribe(() => {
      this.fetchBussinessDetails();
    }));
  }

  private async fetchBussinessDetails(opts?: any): Promise<void> {
    try {
      const data: any = await this.profile.getBusinessDetails(opts);
      this.bussinessName = data.businessName;
    } catch (error) {
      console.error(error);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
